/* tslint:disable */
/* eslint-disable */
/**
 * Disponent.Online
 * Disponent.Online API
 *
 * The version of the OpenAPI document: 0.1
 * Contact: service@weberdata.de
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
// @ts-ignore
import { Land } from '../models';
// @ts-ignore
import { Message } from '../models';
/**
 * LandService - axios parameter creator
 * @export
 */
export const LandServiceAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Liefert eine Liste von Laendern
         * @summary Land
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaender: async (options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/laender`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * Liefert eine Liste von Länderkennzeichen anhand der Suchkriterien
         * @summary Länderkennzeichensuche
         * @param {string} [lkz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLaender: async (lkz?: string, options: any = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/laender/search`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (lkz !== undefined) {
                localVarQueryParameter['lkz'] = lkz;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter, options.query);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * LandService - functional programming interface
 * @export
 */
export const LandServiceFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = LandServiceAxiosParamCreator(configuration)
    return {
        /**
         * Liefert eine Liste von Laendern
         * @summary Land
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getLaender(options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Land>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getLaender(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * Liefert eine Liste von Länderkennzeichen anhand der Suchkriterien
         * @summary Länderkennzeichensuche
         * @param {string} [lkz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async searchLaender(lkz?: string, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<Land>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.searchLaender(lkz, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * LandService - factory interface
 * @export
 */
export const LandServiceFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = LandServiceFp(configuration)
    return {
        /**
         * Liefert eine Liste von Laendern
         * @summary Land
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getLaender(options?: any): AxiosPromise<Array<Land>> {
            return localVarFp.getLaender(options).then((request) => request(axios, basePath));
        },
        /**
         * Liefert eine Liste von Länderkennzeichen anhand der Suchkriterien
         * @summary Länderkennzeichensuche
         * @param {string} [lkz] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchLaender(lkz?: string, options?: any): AxiosPromise<Array<Land>> {
            return localVarFp.searchLaender(lkz, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * LandService - interface
 * @export
 * @interface LandService
 */
export interface LandServiceInterface {
    /**
     * Liefert eine Liste von Laendern
     * @summary Land
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandServiceInterface
     */
    getLaender(options?: any): AxiosPromise<Array<Land>>;

    /**
     * Liefert eine Liste von Länderkennzeichen anhand der Suchkriterien
     * @summary Länderkennzeichensuche
     * @param {string} [lkz] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandServiceInterface
     */
    searchLaender(lkz?: string, options?: any): AxiosPromise<Array<Land>>;

}

/**
 * LandService - object-oriented interface
 * @export
 * @class LandService
 * @extends {BaseAPI}
 */
export class LandService extends BaseAPI implements LandServiceInterface {
    /**
     * Liefert eine Liste von Laendern
     * @summary Land
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandService
     */
    public getLaender(options?: any) {
        return LandServiceFp(this.configuration).getLaender(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * Liefert eine Liste von Länderkennzeichen anhand der Suchkriterien
     * @summary Länderkennzeichensuche
     * @param {string} [lkz] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof LandService
     */
    public searchLaender(lkz?: string, options?: any) {
        return LandServiceFp(this.configuration).searchLaender(lkz, options).then((request) => request(this.axios, this.basePath));
    }
}
